import { FC } from 'react';

import { ClientPod } from '../../../generated/graphql';
import { useClientRequiredFieldsAndPod } from '../../../hooks/useClientRequiredFieldsAndPod';
import {
  getContactEmailByPod,
  THS_PHONE_NUMBER,
} from '../../../utilities/getContactEmailByPod';

const THSPolicyVerbiage: FC = () => {
  const { clientPod } = useClientRequiredFieldsAndPod();

  // Determine contact email based on client pod
  const contactEmail = getContactEmailByPod(clientPod ?? ClientPod.Other);

  return (
    <div className="mt-6 rounded-lg border border-amber-200 bg-amber-50 p-4">
      <h5 className="mb-3 text-sm font-semibold text-gray-700">
        Important Policy Information
      </h5>
      <div className="space-y-3 text-sm text-gray-900">
        <p>
          Rates are based on initial reservation details and are subject to
          change based on any early departures, extensions, or cancellations.
        </p>
        <p>
          If the guest(s) leaves before the listed check-out date above, please
          contact{' '}
          <a
            href={`mailto:${contactEmail}`}
            className="font-medium text-blue-600 hover:text-blue-500"
          >
            {contactEmail}
          </a>{' '}
          or{' '}
          <a
            href={`tel:${THS_PHONE_NUMBER}`}
            className="font-medium text-blue-600 hover:text-blue-500"
          >
            {THS_PHONE_NUMBER}
          </a>{' '}
          on or before the departure date so we can ensure proper billing. We
          may hold you financially responsible for the room nights unaccounted
          for, should you leave the property early without notifying Team
          Housing.
        </p>
        <div>
          <h6 className="mb-2 font-semibold text-gray-800">
            Policy Regarding Changes to Reservation
          </h6>
          <p>
            Client must notify Team Housing before the cancellation date period
            stated by the hotel if the reservation needs to be changed,
            modified, or canceled to avoid cancellation charges. If Team Housing
            Solutions is not notified before the posted cancellation period for
            the hotel Client is responsible for all cancellation fees assessed
            by the hotel and Team Housing Solutions shall not refund any prepaid
            amounts.
          </p>
        </div>
      </div>
    </div>
  );
};

export default THSPolicyVerbiage;
